'use client';

import { useMemo } from 'react';
import { VisibilityState } from '@tanstack/react-table';

import { useMetricsRegistry } from '../provider';
import { CALL_COLUMNS, createMetricColumn } from './columns';

export type CallColumn = ReturnType<typeof createMetricColumn> | (typeof CALL_COLUMNS)[number];

function useColumnsCtx() {
  const { metricsSchema, isLoading } = useMetricsRegistry();

  // build full column list
  const state = useMemo(() => {
    const cols = [...CALL_COLUMNS];
    const invisible: VisibilityState = {};
    metricsSchema.forEach(({ key, label }) => {
      cols.push(createMetricColumn(key as string, label as string));
      const accessor = 'metrics_' + key;
      invisible[accessor] = true; // hide by default
    });
    return { columns: cols, invisible };
  }, [metricsSchema]);

  return { columns: state.columns, visibility: state.invisible, isLoading };
}

export { useColumnsCtx };
